import {sessionData} from './stores.js'

import {auth} from './firebase'
import axios from 'axios'
import { getAuth, RecaptchaVerifier, GoogleAuthProvider, signInWithPopup, OAuthProvider } from 'firebase/auth';
import {getUserData} from './userdata'
import {push, pop, replace} from 'svelte-spa-router'
import {makeOrder} from './payments'


const provider = new GoogleAuthProvider()
const aprovider = new OAuthProvider('apple.com');

aprovider.addScope('email');

// function which signs in the user using Google
 async function registerUser () {
    let session
    sessionData.subscribe(s => session = s)

      const {
          email,
          localId,
          emailVerified,
          displayName,
          photoUrl,
          passwordHash,
          passwordUpdatedAt,
          validSince,
          disabled,
          lastLoginAt,
          accessToken,
          createdAt,
          customAuth,
          lastRefreshAt,
        } = session.user

      const userObject = {
          email: email ? email : session.signin_user.email,
          localId : session.user.uid,
          emailVerified,
          displayName : session.signin_user.displayName,
          photoUrl : "",
          passwordHash : session.signin_user.state,
          passwordUpdatedAt : 0.0,
          validSince : "",
          disabled : false,
          lastLoginAt : session.user.metadata.lastLoginAt,
          createdAt : session.user.metadata.createdAt,
          customAuth : false,
          lastRefreshAt : "",
          location : session.signin_user.location,
          language : "sv",
          dob: session.signin_user.dob,
        }

    try{
     const res = await axios.post(process.env.BASE_GAMBIT_URL + "users/adduser" , userObject, {
          headers: {'Authorization': `Bearer ${accessToken}`}
        })

      setTimeout (async () => {
            await getUserData()
            push('/play')

      }, 500)


    }
    catch (e) {


              sessionData.update(s => ({...s, serverError: e.response.statusText}))
              setTimeout(() => {
                      window.location.href = "/#/Login";
                      window.location.reload()
              },3000)

    }












            // sessionData.update(s => {

              // return s
            // })



    }



 function signInWithApple() {
    sessionData.update(d => ({...d, isAuthenticating: true}))
    signInWithPopup(auth, aprovider)
      .then((result) => {

        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = OAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;

        // The signed-in user info.
          const user = result.user;


          sessionData.update(d => {d.user = user; d.token = token; return d})

        getUserData()



        /* registerUser(user,"Sweden ","se", "1990-01-01") */
        // ...
      }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The AuthCredential type that was used.
        const credential = OAuthProvider.credentialFromError(error);
        sessionData.update(d => ({...d, isAuthenticating: false}))
      });


    }

 function signInWithGoogle() {
    sessionData.update(d => ({...d, isAuthenticating: true}))
    signInWithPopup(auth, provider)
      .then((result) => {

        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;

        // The signed-in user info.
          const user = result.user;


          sessionData.update(d => {d.user = user; d.token = token; return d})
          sessionData.update(d => {d.signin_user.email = user.email; return d})


        getUserData()



        /* registerUser(user,"Sweden ","se", "1990-01-01") */
        // ...
      }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        sessionData.update(d => ({...d, isAuthenticating: false}))
      });


    }





export {registerUser, signInWithGoogle, signInWithApple}
